import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export class SterilizationEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.vetSpecialist = null;
        this.labelId = null;
        this.conclusion = null;

        if (initObjectParams && initObjectParams.labelId) {
            this.labelId = initObjectParams.labelId;
        }
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {
        return {
            vetSpecialist: {},
            labelId: {},
            conclusion: {}
        }
    }

    static get validationFieldLabels() {
        return {
            vetSpecialist: 'Ветеринар',
            labelId: 'Бирка',
            conclusion: 'Заключение'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.vetSpecialist = data['vetSpecialist'];
        this.labelId = data['labelId'];
        this.conclusion = data['conclusion']
    }

}